import { AnimationBaseController, Game, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameCollectableTypeEnum, GameModel, GameMoveableObstacleTypeEnum, GameObstacleTypeEnum } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { SpineAnimationBaseController } from '../Common/SpineAnimationBaseController';
import { LevelEvents } from '../../Constants/Events';
import { Rectangle } from 'pixi.js';

export interface IUICollectableItemControllerOptions {
    type: GameCollectableTypeEnum;
    index: number;
    onClick: (type: GameCollectableTypeEnum, index: number) => void;
}

enum AnimationEnum {
    idle = 'ui_xxx_idle',
    active = 'ui_xxx_active',
    collect = 'ui_xxx_collect',
    press = 'ui_xxx_press',
    splash = 'ui_xxx_splash',
    road = 'road_xxx_idle',
    roadCollect = 'road_xxx_collect',
}

enum stateEnum {
    none,
    idle,
    active,
}

export class UICollectableItemController extends AnimationBaseController {
    $model: Map<string, boolean>;

    private _type: GameCollectableTypeEnum = GameCollectableTypeEnum.none;
    private _index: number = 0;
    private spine: SpineAnimationBaseController;
    private animName: string;
    private currentAnimation;
    private lastAnimation;

    public shine = false;
    public active = false;

    public resources = {};

    public constructor(
        @Inject private _options: IUICollectableItemControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('UICollectableItemController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        const watches = {};
        watches[this._options.type] = (s: boolean) => {
            this.setActive(s);
        }


        return <IAnimationControllerConfiguration>{
            modelWatch: watches,
            onPointerDown: () => {
                if (this._options.onClick) {
                    this._options.onClick(this._type, this._index);
                }
            }
        };
    }

    protected onInitialize(): void {
        this._type = this._options.type;
        this._index = this._options.index;

        this.display.interactive = true;
        this.display.buttonMode = true;

        this.prepareSpine();
        this.display.hitArea = new Rectangle(-125, -125, 250, 250);
    }

    private prepareSpine() {

        // this.display.children.forEach((container)=>{
        //     container.visible = false;
        // })

        switch (this._options.type) {
            case GameCollectableTypeEnum.bat:
                this.animName = 'bat';
                break;
            case GameCollectableTypeEnum.crypto:
                this.animName = 'ether';
                break;
            case GameCollectableTypeEnum.gun:
                this.animName = "gun";
                break;
            case GameCollectableTypeEnum.horse:
                this.animName = "uni";
                break;
        }
        const animations = Object.values(AnimationEnum);
        for (let i = 0; i < animations.length; i++)
            //@ts-ignore
            animations[i] = animations[i].replace('xxx', this.animName);

        this.addChildController({
            controller: SpineAnimationBaseController,
            options: {
                key: "collectables_spine",
                url: '/images/spine/collectables/collectables_assets_for_animation.json',
                animations: animations,
            }
        }, "spine_u");
        this.spine = this.$childControllers.get("spine_u");

        //bad code :(
        setTimeout(() => {
            this.connectListener.bind(this)();
        }, 10);
    }

    private connectListener() {
        const spine = this.$childControllers.get("spine_u") as SpineAnimationBaseController;
        try {
            spine.getSpine().state.addListener({
                complete: track => this.animationListener(track),
            })
            this.setActive(true);
            this.setActive(false);
        }
        catch {
            if (spine) {
                // console.log(this._options.type, "cant get spine")
                setTimeout(() => this.connectListener.bind(this), 10);
            }
        }
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    public getType(): GameCollectableTypeEnum {
        return this._options.type;
    }

    public setActive(s: boolean, shine: boolean = false) {
        if ((this.active != s) || (shine != this.shine)) {
            if (s) {
                this.gotoAndStop(3);
                if (shine)
                    this.setAnimation(AnimationEnum.splash.replace("xxx", this.animName), true)
                else
                    this.setAnimation(AnimationEnum.collect.replace("xxx", this.animName))
            }
            else {
                if (this.active != s)
                    this.setAnimation(AnimationEnum.press.replace("xxx", this.animName))
                else
                    this.setAnimation(AnimationEnum.idle.replace("xxx", this.animName))
            }
            this.active = s;
            this.shine = shine;
        }
    }

    private animationListener(track: PIXI.spine.core.TrackEntry) {
        if (this.currentAnimation)
            this.lastAnimation = this.currentAnimation;
        this.currentAnimation = null;
        this.animationConveyor();
    }

    private animationConveyor() {
        if (this.lastAnimation == AnimationEnum.collect.replace('xxx', this.animName)) {
            this.setAnimation(AnimationEnum.active.replace('xxx', this.animName), false);
        }
        if (this.lastAnimation == AnimationEnum.press.replace('xxx', this.animName)) {
            this.setAnimation(AnimationEnum.idle.replace('xxx', this.animName), false);
        }
    }
    private setAnimation(name: string, loop: boolean = false) {
        if (this.currentAnimation)
            this.lastAnimation = this.currentAnimation;
        this.currentAnimation = name;
        this.spine.setAnimation(name, loop);
    }

    public startVFX() {

    }
}
